const answers = [
  'Owner may accord (or not accord) Contributor a credit in connection with uses of the Work(s) in its sole discretion. ' +
    ' Contributor hereby grants to Owner the right to use Contributor’s name, likeness, logos, marks, and biographical' +
    ' information in connection with the Work(s).',

  'Owner may accord (or not accord) Contributor a credit in connection with uses of the Work(s) in its sole discretion;' +
    ' provided that if a person performing similar services on the Work(s) is accorded a credit, Contributor shall receive' +
    ' a credit in a substantially similar position, size, prominence, style and form.  No casual or inadvertent failure of' +
    ' Owner to comply with, and no failure of any third party to comply with, the credit provision of this Agreement shall' +
    ' constitute a breach of this Agreement, provided that subsequent to Owner’s receipt of written notice from Contributor' +
    ' of any such failure, Owner uses reasonable efforts to prospectively cure any such failure to comply.  Contributor' +
    ' hereby grants to Owner the right to use Contributor’s name, likeness, logos, marks, and biographical information' +
    ' in connection with the Work(s).',

  'Owner shall use its best efforts to provide the following credit in connection with exploitations' +
    ' and uses of the Work(s) where such credits are customarily provided: [ROLE].  No casual or' +
    ' inadvertent failure of Owner to comply with, and no failure of any third party to comply with,' +
    ' the credit provision of this Agreement shall constitute a breach of this Agreement, provided' +
    ' that subsequent to Owner’s receipt of written notice from Contributor of any such failure,' +
    ' Owner uses reasonable efforts to prospectively cure any such failure to comply.  Contributor' +
    ' hereby grants to Owner the right to use Contributor’s name, likeness, logos, marks, and' +
    ' biographical information in connection with the Work(s).',
];

export default (options) => {
  let content = answers[options.field1];
  let checked = true;

  if (options.field1 === 2) {
    if (options.field2 && options.field2 !== '') {
      content = content.replace('[ROLE]', `”${options.field2}”`);
    } else {
      content = content.replace(
        '[ROLE]',
        `<i>”state the credit to be provided here”</i>`
      );
      checked = false;
    }
  }

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Credit.js